<template>
    <div class="title-form">
        <el-form :model="formData" :rules="rules" ref="titleForm" label-width="130px">
            <!-- 抬头类型 -->
            <el-form-item label="抬头类型：" prop="titleType">
                <el-radio-group v-model="formData.titleType" @change="onTypeChange">
                    <el-radio :label="0">企业</el-radio>
                    <el-radio :label="1">个人/非企业单位</el-radio>
                </el-radio-group>
            </el-form-item>

            <!-- 公司表单 -->
            <template v-if="formData.titleType === 0">
                <el-form-item label="企业名称：" prop="titleName">
                    <el-input placeholder="请输入企业名称" v-model="formData.titleName"></el-input>
                </el-form-item>
                <el-form-item label="税号：" prop="taxNo">
                    <el-input placeholder="请输入税号" v-model="formData.taxNo"></el-input>
                </el-form-item>

                <div class="more-info-title">更多信息（非必填）</div>

                <el-form-item label="开户行：" prop="bankName">
                    <el-input placeholder="请输入公司开户行" v-model="formData.bankName"></el-input>
                </el-form-item>
                <el-form-item label="银行账号：" prop="bankNo">
                    <el-input placeholder="请输入开户行账号" v-model="formData.bankNo"></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="address">
                    <el-input placeholder="请输入公司地址" v-model="formData.address"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="phone">
                    <el-input placeholder="请输入公司电话" v-model="formData.phone"></el-input>
                </el-form-item>
            </template>

            <!-- 个人表单 -->
            <template v-else>
                <el-form-item label="个人/单位名称：" prop="titleName">
                    <el-input placeholder="请输入个人/单位名称" v-model="formData.titleName"></el-input>
                </el-form-item>
            </template>

            <!-- 设为默认抬头 -->
            <el-form-item label="设为默认抬头：">
                <el-switch
                    v-model="formData.isDefault"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#3887FE"
                ></el-switch>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: 'InvoiceTitleForm',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        var numOrLetters = (_rule, value, callback) => {
            if (!(/^[0-9A-Z]{6,20}$/.test(value))) {
                callback(new Error("请输入6-20位的数字或大写字母"));
            }
            callback();
        };
        var space = (_rule, value, callback) => {
            if (value && value.trim().length === 0) {
                callback(new Error("输入内容不能全为空格"));
            }
            callback();
        };
        var phone = (_rule, value, callback) => {
            if (!value) {
                callback();
                return;
            }
            if (!/^[\d\-]+$/.test(value)) {
                callback(new Error('仅支持输入数字和"-"'));
                return;
            }
            callback();
        };
        var bankno = (_rule, value, callback) => {
            if (!value) {
                callback();
                return;
            }
            if (!(/^\+?[0-9][0-9]*$/.test(value))) {
                callback(new Error("请输入正确的银行卡号"));
            }
            callback();
        };
        return {
            formData: {
                id: '',
                titleType: 0,
                titleName: '',
                taxNo: '',
                bankName: '',
                bankNo: '',
                address: '',
                phone: '',
                isDefault: 0
            },
            rules: {
                titleType: [
                    { required: true, message: '请选择抬头类型', trigger: 'change' }
                ],
                titleName: [
                    { required: true, message: '请填写名称', trigger: 'blur' },
                    { validator: space, trigger: 'blur' },
                    { max: 100, message: '名称不能超过100个字符', trigger: 'blur' }
                ],
                taxNo: [
                    { required: true, message: '请填写公司税号', trigger: 'blur' },
                    { validator: space, trigger: 'blur' },
                    { validator: numOrLetters, trigger: 'blur' },
                    { min: 6, max: 20, message: '请输入6-20位的数字或大写字母', trigger: 'blur' }
                ],
                bankName: [
                    { validator: space, trigger: 'blur' }
                ],
                bankNo: [
                    { validator: space, trigger: 'blur' },
                    { validator: bankno, trigger: 'blur' }
                ],
                address: [
                    { validator: space, trigger: 'blur' }
                ],
                phone: [
                    { validator: phone, trigger: "blur" },
                ]
            }
        };
    },
    watch: {
        data: {
            handler(val) {
                if (val && Object.keys(val).length > 0) {
                    this.formData = {
                        id: val.id || '',
                        titleType: val.titleType !== undefined ? val.titleType : 0,
                        titleName: val.titleName || '',
                        taxNo: val.taxNo || '',
                        bankName: val.bankName || '',
                        bankNo: val.bankNo || '',
                        address: val.address || '',
                        phone: val.phone || '',
                        isDefault: val.isDefault !== undefined ? val.isDefault : 0
                    };
                } else {
                    // 添加时重置表单
                    this.formData = {
                        id: '',
                        titleType: 0,
                        titleName: '',
                        taxNo: '',
                        bankName: '',
                        bankNo: '',
                        address: '',
                        phone: '',
                        isDefault: 0
                    };
                    this.$nextTick(() => {
                        this.$refs.titleForm && this.$refs.titleForm.clearValidate();
                    });
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        onTypeChange(val) {
            this.$refs.titleForm.clearValidate();
            this.$emit('type-change', val);
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.$refs.titleForm.validate((valid) => {
                    if (valid) {
                        resolve({ ...this.formData });
                    } else {
                        reject();
                    }
                });
            });
        },
        resetForm() {
            this.$refs.titleForm.resetFields();
            this.formData = {
                id: '',
                titleType: 0,
                titleName: '',
                taxNo: '',
                bankName: '',
                bankNo: '',
                address: '',
                phone: '',
                isDefault: 0
            };
        }
    }
};
</script>

<style lang="less" scoped>
.title-form {
    padding: 0 10px;

    .more-info-title {
        font-size: 14px;
        color: #909399;
        margin-bottom: 16px;
    }
    .el-form-item {
        margin-bottom: 22px !important;
    }
    ::v-deep .el-form-item__error{
        font-size: 12px !important;
    }

    ::v-deep .el-form-item__label {
        font-size: 14px;
        color: #0F172A;
        font-weight: bold;
    }

    ::v-deep .el-input__inner {
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        border: 1px solid #D0D5DD;

        &:focus {
            border-color: #3B7DFF;
        }
    }

    ::v-deep .el-radio {
        margin-right: 24px;
        font-size: 14px;
        color: #0F172A;
    }
}
</style>
